import React, {Component} from 'react'
import Grid from "../../../Utils/Grid";
import {TableHeaderColumn} from "react-bootstrap-table";
import {standardActions} from "../../../Utils/Grid/StandardActions";
import Link from "react-router-dom/es/Link";
import Card from "Utils/Cards/Card"
import Header from "Utils/Grid/Header";
import {formatActivo} from "Utils/renderField/renderReadField"

export default class TIposVehiculoList extends Component{
    componentWillMount() {
        const { listar, page } = this.props;
        listar(page);
    }

    render() {
        const { listar: onPageChange, onSortChange, eliminar } = this.props;
        const { data, loader, page } = this.props;
        return(
            <div className="mb-4 col-12">
                <Card
                    icon="configuraciones_activo"
                    titulo="TIPOS DE VEHÍCULOS"
                    subtitulo="Del sistema">
                    <Header to="tipo_vehiculo/crear" textBtn="CREAR TIPO" {...this.props} />
                    <Grid hover striped data={data} loading={loader} onPageChange={onPageChange}
                          onSortChange={onSortChange} page={page} >
                        <TableHeaderColumn
                            isKey
                            dataField="id"
                            dataAlign="center"
                            dataSort
                            width='20%'
                            dataFormat={standardActions({ editar: "tipo_vehiculo", eliminar})}
                        />
                        <TableHeaderColumn
                            dataField="nombre"
                            dataSort
                            width='15%'
                        >
                            TIPO VEHÍCULO
                        </TableHeaderColumn>
                         <TableHeaderColumn
                            dataField="validar_placa"
                            dataFormat={formatActivo}
                            dataAlign="center"
                            dataSort
                            width='15%'
                        >
                            VALIDAR PLACA
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="prefijo_placa"
                            dataSort
                            width='15%'
                        >
                            PREFIJO PLACA
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataAlign="left"
                            dataField="id"
                            width='15%'
                            dataSort
                        >
                            CÓDIGO
                        </TableHeaderColumn>
                        <TableHeaderColumn width='20%'/>
                    </Grid>
                </Card>
            </div>
        )
    }
}
